import { ReactNode, useEffect, useRef } from "react"
import { useMsal } from "@azure/msal-react"
import { clearPreviewCache } from "@/utils/previewCache"
import { PreviewAccountContext } from "@/utils/previewAccount"

type Props = { children: ReactNode }

export function PreviewSessionBoundary({ children }: Props) {
    const { instance, accounts = [] } = useMsal()
    const account = instance.getActiveAccount() ?? accounts[0]
    const accountKey = account?.homeAccountId || account?.localAccountId || null
    const previousAccount = useRef(accountKey)

    useEffect(() => {
        if (previousAccount.current !== null && previousAccount.current !== accountKey) {
            clearPreviewCache()
        }
        previousAccount.current = accountKey
        // `accounts` is included so MSAL account/logout events trigger this
        // boundary even when the active-account object is unchanged.
    }, [accountKey, accounts])

    useEffect(
        () => () => {
            if (previousAccount.current !== null) clearPreviewCache()
        },
        []
    )

    return <PreviewAccountContext.Provider value={accountKey ?? "signed-out"}>{children}</PreviewAccountContext.Provider>
}
